import React from 'react';
import { Reveal } from '../ui-custom/Reveal';
import { FilterAnimationImproved } from '../ui-custom/FilterAnimationImproved';
import { useLanguage } from '../../contexts/LanguageContext';
import { theme } from '../../utils/theme';

export const FilterDemoSection = ({ systemActive, onToggleSystem }) => {
  const { t } = useLanguage();
  
  return (
    <section id="filter-demo" className="py-24 relative z-10 border-t" style={{ borderColor: theme.colors.border, backgroundColor: 'rgba(255,255,255,0.005)' }}>
      <div className="max-w-7xl mx-auto px-4">
        <Reveal>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-400">
              {t.filterDemo.title}
            </h2>
            <p className="text-xl max-w-3xl mx-auto" style={{ color: theme.colors.textMuted }}>
              {t.filterDemo.subtitle}
            </p>
          </div>
        </Reveal>
        
        <Reveal delay={200}>
          <FilterAnimationImproved systemActive={systemActive} onToggle={onToggleSystem} />
        </Reveal>
      </div>
    </section>
  );
};
